/**
 * ComparisonRowLabel — left-most cell of each comparison row. Sticks to
 * the left edge of the horizontally-scrolling grid so labels stay
 * visible while site columns scroll.
 *
 * Linear: MYD-217 (F2).
 */

import { cn } from 'lib/utils'

interface ComparisonRowLabelProps {
	label: string
	className?: string
}

const ComparisonRowLabel = ({ label, className }: ComparisonRowLabelProps) => (
	<div
		className={cn(
			'sticky left-0 z-10 px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500 border-t border-gray-100 border-r',
			className,
		)}
	>
		{label}
	</div>
)

export default ComparisonRowLabel
